export class Data {
    constructor () {
        this.alaert_text = null
        this.alart = false
        this.language = 'eng'
       //table list
    //    this.url = "http://43.255.240.24:5001"
        // this.url = "http://0.0.0.0:5051"
//        this.url = "https://wtc.co.th:5050"
        // this.url = "https://wtc-api.lifelink.co.th:10443"
        this.url = "https://visitor-api.lifelink.co.th:10443"
        



        this.token = null
        this.email = null
        this.header = [],
        this.datatable = []
        this.showtable = false
        // บนนี้ห้ามลบ

       this.newlist = undefined,
       this.holidaylist = undefined,
       this.holidaylist_2565 = undefined,
       this.employeelist = undefined,
       this.Innovation_employeelist = undefined,
       this.employeemorelist = undefined,
       this.approvelist = undefined,
       this.leavelist = undefined,
       this.leavelist_show = undefined,
       this.certificatelist = undefined,
       this.certificatelist_show = undefined,
       this.assetlist = undefined,
       this.assetlist_show = undefined,
       this.benefitlist = undefined,
       this.benefitlist_show = undefined,

       this.loadsync = false

       this.header = null,
       this.datatable = null


       this.test = undefined,

       //news add + edit
       this.title_news = ""
       this.type = null
       this.date_news = new Date().toISOString().substr(0, 10)
       this.file_news = null
       this.newother = ""
       this.id = ""
       this.create = ""


       this.test = "Bearer 424f384f1822086eeec87115cc6eb7ee248c6250d5e61d49f07af7a366f050ac",
       this.com = 0,
       this.token = null
       this.error_status = null
       this.login_status = 0
       //home
       this.items = [{
           title: 'จัดการ User',
           icon: 'mdi-account',
           com : 0
       },
       {
           title: 'จัดการห้องประชุม',
           icon: 'mdi-account-group',
           com: 1
       },
       {
            title: 'จัดการอุปกรณ์',
            icon: 'mdi-video',
            com: 2
        },
       {
           title: 'จัดการ Booking',
           icon: 'mdi-responsive',
           com: 3
       },
       {
           title: 'Dashboard',
           icon: 'mdi-collage',
           com: 4
       },]    
        this.count_booking = 0,
        this.count_user = 0,
        this.room_close = 0
        this.room_ready = 0

        this.chart_booking_time = [{
            name: 'ครั้ง',
            data: [],
        }, ]

        this.chart_booking_day_data = [{
            name: 'ครั้ง',
            data: [],
        }, ]
        this.chart_booking_day_name = null

        this.chart_booking_data = []
        this.chart_booking_name = null
        this.monitor = []
        this.datatablemonitor =[]
        this.menu = {
            "thai" : {
                "login" : "เข้าสู่ระบบ",
                "username" : "ชื่อผู้ใช้",
                "password" : "รหัสผ่าน",
                "forgot_password" : "ลืมรหัสผ่าน",
                "logout" : "ออกจากระบบ",
                // "monitor" : 'monitor',
                "items" : [{
                    title: 'จัดการ User',
                    icon: 'mdi-account',
                    com : 0
                },
                {
                    title: 'จัดการห้องประชุม',
                    icon: 'mdi-account-group',
                    com: 1
                },
                // {
                //      title: 'จัดการอุปกรณ์',
                //      icon: 'mdi-video',
                //      com: 2
                //  },
                {
                    title: 'จัดการ Booking',
                    icon: 'mdi-responsive',
                    com: 3
                },
                {
                    title: 'Dashboard',
                    icon: 'mdi-collage',
                    com: 4
                },
                {
                    title: 'Monitor',
                    icon: 'mdi-monitor-dashboard',
                    com: 5
                },
            ] ,
                "dashboard": {
                    "unavailable" : "จำนวนห้องที่ไม่ได้ใช้งาน",
                    "unavailable_unit" : "ห้อง",
                    "available" : "จำนวนห้องที่ใช้งาน",
                    "available_unit" : "ห้อง",
                    "user" : "จำนวน Users ที่ใช้งาน",
                    "booking" : "จำนวน Booking",
                    "usage_per_room" : "กราฟแสดงสัดส่วนการใช้ห้องประชุม",
                    "meeting_room_used" : "จำนวนในการใช้ห้องประชุม",
                    "reserving_time" : "จำนวนสถิติเวลาในการใช้ห้องประชุม"
                },
                
            },
            "eng" : {
                "login" : "Sign in",
                "username" : "username",
                "password" : "password",
                "forgot_password" : "Forgot password",
                "logout" : "Log out",
                "items" : [{
                    title: 'User ',  
                    icon: 'mdi-account',
                    com : 0
                },
                {
                    title: 'Meeting room ', 
                    icon: 'mdi-account-group',
                    com: 1
                },
                // {
                    //  title: 'Equipment ',
                    //  icon: 'mdi-video',
                    //  com: 2
                //  },
                {
                    title: 'Booking ',
                    icon: 'mdi-responsive',
                    com: 3
                },
                {
                    title: 'Dashboard',
                    icon: 'mdi-collage',
                    com: 4
                },
                {
                    title: 'Monitor',
                    icon: 'mdi-monitor-dashboard',
                    com: 5
                },
            ] ,
                "dashboard": {
                    "unavailable" : "Unavailable",
                    "available" : "Available",
                    "user" : "Users",
                    "booking" : "Booking",
                    "usage_per_room" : "Meetings",
                    "meeting_room_used" : "Meeting room used",
                    "reserving_time":"Reserving time"
                },
            },
        }

      //   data:[],
      

    }
}
